export default {
  SET_USER: "SET_USER",
  SET_PACIENTE_DATA: "SET_PACIENTE_DATA",
};
